// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"ec225fb9","281":"85d710c5","577":"d75f7d01","607":"a52f7ad1","624":"49a99264","714":"deda91db","813":"3cdcfcbe","851":"f150c49a","860":"57eea478","873":"caeb7f04","927":"7b89cba0"}[chunkId] + ".chunk.js";
};